import React from 'react';
import { alpha, Box, Typography, useTheme } from '@mui/material';
import { Check } from '@mui/icons-material';

type Props = {
  label: string;
  checked: boolean;
  onClick: () => void;
  dense?: boolean;
};

export function AgencyFilterCheckboxRow({ label, checked, onClick, dense }: Props) {
  const theme = useTheme();
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        textAlign: 'left',
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        py: dense ? 0.5 : 1,
        px: 1.5,
        '&:hover': { bgcolor: alpha(theme.palette.action.hover, 0.08) },
      }}
    >
      <Box
        sx={{
          width: 20,
          height: 20,
          border: `2px solid ${theme.palette.primary.main}`,
          borderRadius: 0.5,
          mr: 1.5,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: checked ? theme.palette.primary.main : 'transparent',
        }}
      >
        {checked && <Check sx={{ fontSize: 16, color: 'white' }} />}
      </Box>
      <Typography variant="body2">{label}</Typography>
    </Box>
  );
}
